<template>
  <div class="main">

    <nav :class="{ 'navbar-bg-blue': isNavbarBlue }" class="navbar navbar-expand-lg fixed-top text-white" style="overflow:visible">
        <div class="container d-flex flex-row align-items-center justify-content-between w-100 p-3">
            <a class="navbar-brand d-flex flex-row gap-4 align-items-center p-0" href="#">
              <img 
                  alt="Logo" 
                  width="230px" 
                  class="" 
                  src="@/assets/teg_inl_logo.png"
              />
            </a>
            <button class="navbar-toggler text-light" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
              <span class="navbar-toggler-icon text-light"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
              <div class="w-100 d-flex flex-column flex-lg-row align-items-center justify-content-end gap-5">
                  <a @click="activeSection = 'projects'" :class="{ active: activeSection === 'projects' }"  class="d-flex flex-column align-items-center _nav-item " href="#projects">
                    <h6><i class="fas fa-project-diagram"></i></h6>
                    <h6 class="fw-bold">Projects</h6> 
                  </a>
                  <a @click="activeSection = 'about'" :class="{ active: activeSection === 'about'}"  class="d-flex flex-column align-items-center _nav-item " href="#about">
                    <h6><i class="fas fa-info"></i></h6>
                    <h6 class="fw-bold">About</h6> 
                  </a>
                  <a @click="activeSection = 'competences'" :class="{ active: activeSection === 'competences'}"  class="d-flex flex-column align-items-center _nav-item " href="#competences">
                    <h6><i class="fas fa-tools"></i></h6>
                    <h6 class="fw-bold">Competences</h6> 
                  </a>
                  <a @click="activeSection = 'team'" :class="{ active: activeSection === 'team' }"  class="d-flex flex-column align-items-center _nav-item " href="#team">
                    <h6><i class="fas fa-users"></i></h6>
                    <h6 class="fw-bold">Team</h6> 
                  </a>
                  <a @click="activeSection = 'contact'" :class="{ active: activeSection === 'contact' }"  class="d-flex flex-column align-items-center _nav-item " href="#contact">
                    <h6><i class="fas fa-envelope"></i></h6>
                    <h6 class="fw-bold">Contact</h6> 
                  </a>
                  <button 
                    @click="toggleTheme" 
                    class="btn icon-header d-flex align-items-center text-white _nav-item" 
                    :aria-label="isDarkMode ? 'Switch to light theme' : 'Switch to dark theme'">
                    <h5><i :class="isDarkMode ? 'fas fa-sun' : 'fas fa-moon'" class="text-white"></i></h5>
                    <span class="visually-hidden">Toggle theme</span>
                  </button>
              </div>
            </div>
        </div>
    </nav>

    <div ref="banner" class="banner fullscreen-video-container ">
      <video autoplay muted loop class="fullscreen-video">
        <source src="@/assets/videoIntro_1280.mp4" type="video/mp4" />
        Seu navegador não suporta vídeos.
      </video>
      <a href="#projects" class="scroll-button">
        <h6 class="text-center display-6 text-light cursor-pointer"><i class="fas fa-chevron-down"></i> See Projects</h6>
      </a>
    </div>

    <div class="dots-container">
      <div
        v-for="(dot, index) in dots.filter(dot => dot.isActive)"
        :key="index"
        :class="['dot', { active: dot.isActive }]"
        :style="{
          top: `${dot.top}px`,
          left: `${dot.left}px`,
          width: dot.isActive ? '5px' : '3px',
          height: dot.isActive ? '5px' : '3px',
          backgroundColor: dot.isActive ? Math.random() > 0.5 ? '#007bff' : '#820bea' : 'rgba(178, 175, 175, 0.199)'
        }"
      ></div>
    </div>

    <!-- <div class="container">
      <video class="w-100" autoplay muted loop>
        <source src="@/assets/teg.mp4" type="video/mp4">
        Your browser does not support the video tag.
      </video>
    </div> -->

    <div class="container" id="projects">
      <br>
      <br>

      <div class="mb-3 position-relative" style="z-index:3 !important">
        <input 
          v-model="searchQuery" 
          type="text" 
          class="form-control" 
          placeholder="Type to filter projects..."
        />
      </div>

      <br>

      <div class="position-relative d-flex d-md-none">
        <select v-model="selectedTag" class="form-select minimal-select" aria-label="Default select example">
          <option value="All">All</option>
          <option v-for="(tag, index) in tags" :key="index">
            {{ tag }}
          </option>
        </select>
        <i class="select-arrow fas fa-chevron-down"></i> 
      </div>

      <div class="d-none d-md-flex flex-row w-100 mt-1 tags rounded-2">
        <div 
          v-for="(tag, index) in tags" :key="index" 
          class="tagSelect  p-2 text-light flex-grow-1 d-flex align-items-center justify-content-center cursor-pointer" 
          :class="{'flex-grow-2': selectedTag == tag }"
          :style="{ backgroundColor: getColor(tag) }"
          @mouseenter="selectedTag = tag; tagClicked = false"
          @mouseleave="tagClicked == false ? selectedTag = 'All': pass" 
          @click="
          if (tagClicked == false){
            selectedTag = tag; 
            clickedTag = tag;
            tagClicked = true
          }else if (clickedTag == tag){
            selectedTag = 'All'
            clickedTag = 'All'
            tagClicked = false
          }else if (clickedTag != tag){
            selectedTag = tag
            tagClicked = true
          }"
        >
          <h6><i :class="getIcon(tag)"></i></h6>
          <span v-if="selectedTag == tag" class="ms-2">{{ tag }}</span>
        </div>
      </div>

      <br>
      <br>

      <div class="row">
        <div 
          v-for="presentation in filteredPresentations" 
          v-bind:key="presentation.projectID"
          data-aos="zoom-in" 
          data-aos-duration="1000" 
          class="col-12 col-md-6 col-lg-4 col-xl-3" 
          style="min-width: 200px; " 
        >

          <div 
            class="presentationCard overflow-hidden card bg-body my-3 border border-4"
            :class="{ 'blur-sm': (this.codeInserted && presentation.in_code === false) }"
            @click="openPresentation(presentation.projectID);" 
            @mouseover="hoveredPresentation = presentation.projectID"
            @mouseleave="hoveredPresentation = null"
          >
            <div class="card-header overflow-hidden bg-body border-0" 
              :style="presentation.thumbnail
                ? { backgroundImage: `url(${presentation.thumbnail})`, backgroundSize: 'cover', backgroundPosition: 'center', height: '200px',   filter: hoveredPresentation === presentation.projectID ? 'saturate(0.4)' : 'brightness(0.7)'  }
                : { backgroundColor: '#f8f9fa', height: '200px' }">
                <span v-if="!presentation.thumbnail">
                  {{ presentation.description.length > 190 ? presentation.description.substring(0, 190) + '...' : presentation.description }}
                </span>
            </div>
            <div class="card-body p-0">
              <div class="p-3">
                <div v-if="hoveredPresentation != presentation.projectID">
                  <h6 style="font-size:24px" class="display-6">{{ presentation.projectName }}</h6>
                </div>
                <div v-else>
                  <h6 style="font-size:24px" class="display-6"><i class="fas fa-eye me-2"></i><span>View </span></h6>
                </div>
              </div>
              <div class="d-flex flex-row w-100 mt-1">
                <div v-for="(tag, index) in presentation.tags" :key="index" style="height:5px" class="flex-grow-1" :style="{ backgroundColor: getColor(tag) }">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <br> 
    <br>
    <br>

    <div 
      class="4" 
      :style="{
        position: 'relative',
        backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.65), rgba(0, 0, 0, 0.119)), url(' + aboutBanner + ')',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed', 
      }">
      <br>
      <br>

      <div id="about" class="d-flex justify-content-center mb-4">
        <h4 class="text-center display-4 text-light">About Us</h4>
      </div>

      <br>
      <br>

      <div class="container">
        <div class="row">
          <div class="col-12 col-xl-6" data-aos-duration="1000" data-aos="fade-right">
            <p style="font-size:20px;text-align: justify;" class="display-6 mb-4 pe-4 text-light">
              The Technology Engineering Group (TEG) is a cohesive, multifaceted engineering team that promotes INL’s core R&D&I skills, 
              in particular in the area of system engineering. It aims to expand the installed capacities for an interdisciplinary approach 
              to transform concepts into high-quality nano-technology based products and services. 
              The multidisciplinary team of Engineers from different areas, namely Mechanical, Electronic, Computer Engineering, Physics, 
              and work very closely with each other and ensure continuity between the knowledge accumulated at 
              INL and the existing knowledge in companies, enabling a faster and more effective data transfer.
            </p>
          </div>
          <div class="col-12 col-xl-6" data-aos="fade-left" data-aos-duration="1000" >
            <video class="w-100 rounded" autoplay muted loop>
              <source src="@/assets/teg.mp4" type="video/mp4">
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      </div>

      <br>
      <br>
      <br>

    </div>

    <br>
    <br>
    <br>
    <br>

    <div class="container d-flex justify-content-center mb-4">
      <span data-aos-duration="1000" data-aos="zoom-in" class="text-center display-6 fst-italic">"Creation of an Application Engineering Unit to reinforce the activities of valuing and transferring knowledge from INL to companies."</span>
    </div>

    <br>
    <br>
    <br>
    <br>

    <div 
      class="bg-body-tertiary"
      :style="{
          position: 'relative',
          backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.15), rgba(0, 0, 0, 0.119)), url(' + competencesBanner + ')',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundAttachment: 'fixed', 
        }"
      >
      <br>
      <br>

      <div id="competences" class="d-flex justify-content-center mb-4">
        <h4 class="text-center display-4 text-light">Competences</h4>
      </div>

      <br>
      <br>

      <div class="container">
        <div class="row row-cols-1 row-cols-md-2 g-4">
          <div class="col">
            <div data-aos-duration="1000" data-aos="fade-right" class="card h-100 bg-body bg-opacity-75">
              <div class="card-header border-0 bg-body bg-opacity-75 text-center p-3">
                <h1 class="fas fa-microchip mb-2"></h1>
                <h3>Electronic Engineering</h3>
              </div>
              <div class="card-body bg-body bg-opacity-75">
                <ul>
                  <li>Design IOT based data acquisition systems for physical and biochemical sensors. Analog and digital Electronics design and development and System integration</li>
                  <li>Embedded systems, FPGA and microprocessor programming</li>
                  <li>Design and fabrication of mixed signal interfaces</li>
                  <li>Design. modeling and simulation of RF operatinf components</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col">
            <div data-aos-duration="1000" data-aos="fade-left" class="card h-100  bg-body bg-opacity-75">
              <div class="card-header border-0 bg-body bg-opacity-75 text-center p-3">
                <h1 class="fas fa-laptop-code mb-2"></h1>
                <h3>Computer Engineering</h3>
              </div>
              <div class="card-body bg-body bg-opacity-75">
                <ul>
                  <li>Web based platform design and development (cloud)</li>
                  <li>Native desktop software development</li>
                  <li>Native mobile app development</li>
                  <li>Data Visualization Interface Design UI/UX User Interface and Experience</li>
                  <li>Data Science; Data Extraction</li>
                  <li>Virtual Reality</li>
                  <li>Augmented Reality</li>
                  <li>Interaction Design</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col">
            <div data-aos-duration="1000" data-aos="fade-right" class="card h-100 bg-body bg-opacity-75">
              <div class="card-header border-0 bg-body bg-opacity-75 text-center p-3">
                <h1 class="fas fa-eye mb-2"></h1>
                <h3>Computer Vision</h3>
              </div>
              <div class="card-body bg-body bg-opacity-75">
                <ul>
                  <li>Image Analysis and Segmentation</li>
                  <li>Feature Extraction, Object recognition, Depth Estimation and Reconstruction</li>
                  <li>Augmented Reality</li>
                  <li>Spatial Computing</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col">
            <div data-aos-duration="1000" data-aos="fade-left" class="card h-100 bg-body bg-opacity-75 ">
              <div class="card-header border-0 bg-body bg-opacity-75 text-center p-3">
                <h1 class="fas fa-robot mb-2"></h1>
                <h3>Artificial Intelligence</h3>
              </div>
              <div class="card-body bg-body bg-opacity-75">
                <ul>
                  <li>Pattern Recogntionn</li>
                  <li>Machine Learning & AI based algorithm</li>
                  <li>Neural networks & Deep Learning</li>
                  <li>Big Data & Data Mining</li>
                  <li>Optimization</li>
                  <li>Data Prediction</li>
                  <li>Pattern Extraction</li>
                  <li>Digital Signal Processing</li>
                  <li>Computer Vision & Image Processing</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col w-100">
            <div data-aos-duration="1000" data-aos="fade-right" class="card h-100  bg-body bg-opacity-75">
              <div class="card-header border-0 bg-body bg-opacity-75 text-center p-3">
                <h1 class="fas fa-cogs mb-2"></h1>
                <h3>Mechanical Engineering</h3>
              </div>
              <div class="card-body bg-body bg-opacity-75">
                <ul>
                  <li>Design conceptualisation and modeling</li>
                  <li>Mechanical design and manufacturing</li>
                  <li>Design verification through Multiphysics (CAE) Simulations: evaluation of concepts structural, thermal and aerodynamic performance</li>
                  <li>Automation Systems design and implementation</li>
                  <li>Additive and subtractive manufacturing</li>
                  <li>Material processing using LASER technology</li>
                  <li>Design testing and validation</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <br>
      <br>

    </div>

    <br>
    <br>

    <div id="team" class="d-flex justify-content-center mb-4">
      <h4 class="text-center display-4">Team</h4>
    </div>

    <br>
    <br>

    <div class="container">
      <div class="row g-4">
        <div v-for="(user, index) in getUsers" :key="index" class="col-12 col-md-6 col-lg-4 col-xl-3">
          <div @click="userSelected=user;this.$nextTick(() => {this.$refs.UserModal.show();});"  class="card user p-0 m-4">
            <div class="card-body">
              <img class="mb-3 w-100" data-aos="zoom-out" data-aos-duration="1000" :src="user.picturebase64">
              <h5>{{ user.name }}</h5>
            </div>
          </div>
        </div>
      </div>
    </div>

    <br>
    <br>

    <div id="contact" class="d-flex justify-content-center mb-4">
      <h4 class="text-center display-4">Contact</h4>
    </div>

    <br>
    <br>

    <div 
      class="d-flex w-100" 
      :style="{
        position: 'relative',
        backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.15), rgba(0, 0, 0, 0.119)), url(' + imageUrl + ')',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }"
    >
      <div class="container py-4">
          <div class="card my-4" data-aos="zoom-in">
              <div class="card-body bg-body row">
                  <div class="col col-6 p-3">
                      <h5>Get in Touch</h5>
                      <br>
                      <p>
                        Please get in touch with us if you are interested and want to know more about our projects.
                        For any inquiries please contact <a class="text-primary" href="mailto:teg@inl.int">teg@inl.int</a>.
                      </p>
                  </div>
                  <div class="col col-6 p-3">
                      <div class="mb-3 d-flex flex-column">
                          <label class="fw-bold">Address</label>
                          <span>
                            Avenida Mestre José Veiga s/n
                            4715-330 Braga
                            Portugal
                          </span>
                      </div>
                      <div class="mb-3 d-flex flex-column">
                          <label class="fw-bold">Phone</label>
                          <span>Tel. (351) 253 140 112</span>
                      </div>
                      <div class="mb-3 d-flex flex-column">
                          <label class="fw-bold">Email</label>
                          <span>teg@inl.int</span>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </div>

    <div class="bottom-0 w-100 d-flex flex-lg-column px-4 py-2 text-light" style="background-color:#005f80;box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.096), 0 -4px 4px rgba(0, 0, 0, 0) !important;">
      <div class="container p-3 d-flex gap-4 flex-column flex-md-row align-items-center justify-content-between">
        <a style="z-index:1000" href="https://inl.int">
          <img 
            alt="Logo" 
            width="120px" 
            class="" 
            src="@/assets/inl_logo_cinza.png"
          />
        </a>
        <strong>Copyright © 2014-2025 <a href="https://teg.inl.int" class="text-decoration-none">TEG - INL</a>.</strong>
        <button @click="activateTvMode" class="btn btn-light" style="z-index:1000"><i class="fas fa-tv me-1"></i>TV Mode</button>
        <div><b>Version</b>  2.0.0</div>
      </div>
    </div>


    <ModalComponent
      v-if="presentationSelected"
      ref="PresentationModal"
      :title_centered="true"
      :modal_size="'modal-xl'"
      :title="presentationSelected ? presentationSelected.projectName : ' '"
    >
      <template v-slot:body>
        <div class="container">
            <p style="text-align: justify;font-size:14px;">
              {{ presentationSelected.description }}
            </p>

            <div class="d-none d-md-flex flex-row align-items-center justify-content-center gap-3 mb-4">
              <div v-for="(tag, index) in presentationSelected.tags" :key="index" class="mb-2">
                <span class="tag d-flex flex-row align-items-center p-2 text-white rounded" :style="{ backgroundColor: getColor(tag) }">
                  <i :class="getIcon(tag)"></i>
                  <span class="tag-text">{{ tag }}</span>
                </span>
              </div>
            </div>

            <div v-for="(movieTitle, index) in presentationSelected.moviesTitles" :key="index">
              <h6 class="text-center display-6">{{movieTitle}}</h6>

              <br>
              <br>

              <video class="w-100" controls  @contextmenu.prevent controlsList="nodownload noremoteplayback">
                <source :src="getApiBaseUrl + presentationSelected.movies[index]" type="video/mp4">
                Your browser does not support the video tag.
              </video>

              <br>
              <br>
            </div>

            <div v-for="(imageTitle, index) in presentationSelected.imagesTitles" :key="index">

              <h6 class="text-center display-6">{{imageTitle}}</h6>

              <br>
              <br>

              <img @contextmenu.prevent class="w-100" :src="getApiBaseUrl + presentationSelected.images[index]" style="max-width: 1900px;">

              <br>
              <br>
            </div>
        </div>
      </template>

      <template v-slot:footer>
        <p class="footer-notice"><i class="fas fa-exclamation-circle"></i> Confidential Information Notice: This produt information is confidential and 
          intended solely for authorized users. Unauthorized access, disclosure, or distribution 
          of this information is strictly prohibited. By accessing this page, you agree to maintain
          the confidentiability of the information displayed here and use it solely for authorized purposes.
        </p>
      </template>
    </ModalComponent>

    <ModalComponent
      v-if="userSelected"
      ref="UserModal"
      :modal_size="'modal-lg'"
      :title="' '"
    >
      <template v-slot:body>
        <div class="container">
          <div class="card-body d-flex flex-column align-items-center gap-4 p-0">
              <div class="d-flex flex flex-column align-items-center gap-3">
                <img style="width:160px;height:160px;object-fit:cover" class="rounded shadow" :src="userSelected.picturebase64">
                <div class="d-flex flex-column align-items-center gap-1">
                  <h4 class="fw-bold">{{ userSelected.name }}</h4>
                  <h6 class="text-muted">{{ userSelected.email }}</h6>
                </div>
              </div>
              <p style="text-align:justify">{{ userSelected.description }}</p>
            </div>
        </div>
      </template>
    </ModalComponent>

    <ModalComponent
      ref="CodeModal"
      :modal_size="'modal-lg'"
      :title="' '"
      @onCancel="this.checkCodeApprovalFeedback = ''"
    >
      <template v-slot:body>
        <div class="container">
          <div v-if="checkCodeApprovalFeedback" class="alert alert-danger">{{ checkCodeApprovalFeedback }}</div>
          <h4 class="mb-3">Access Code</h4>
          <input v-model="codeInserted" type="text" class="form-control w-100" style="min-width: 300px;" placeholder="Insert the code here..." />
          <button class="btn btn-primary mt-3 w-100" @click="checkCodeApproval()"><i class="fas fa-key me-1"></i>Verify</button>
        </div>
      </template>
    </ModalComponent>

    <ModalConfirmLayout ref="ModalConfirm"></ModalConfirmLayout>

    <div v-if="isTVMode && videosToShow.length > 0" class="tv-mode">
      <video 
        ref="videoElement"
        :src="videosToShow[currentIndexTVMode].src"
        @ended="onVideoEnded()"
        controls
        autoplay
        playsinline
        width="90%"
        height="90%"
        class="video-tv-mode"
      ></video>
      <div class="widgets">
        <img 
          v-if="qrCodeUrl" 
          src="@/assets/teg_inl_logo.png" 
          alt="TEG Logo" 
          class="teg-logo" 
        />
        <img 
          v-if="qrCodeUrl" 
          :src="qrCodeUrl" 
          alt="QR Code" 
          class="qr-code" 
        />
      </div>
      <div class="title-video-tv-mode ">
        <h2 class="text-light">{{ videosToShow[currentIndexTVMode].title }}</h2>
        <p class="text-light">{{ videosToShow[currentIndexTVMode].description }}</p>
      </div>
    </div>

    <button
      v-show="showScrollButton"
      @click="scrollToTop"
      class="scroll-top-btn"
    >
      <i class="fas fa-chevron-up"></i>
    </button>

    <a
      v-show="showScrollButton"
      href="#team"
      class="team-btn"
    >
    <i class="fas fa-users"></i>
    </a>

    <div class="progress-bar-container position-fixed bottom-0 start-0">
      <div class="progress-bar" :style="{ width: scrollProgress + '%' }"></div>
    </div>
  </div>
</template>

<script>
import { usePresentationStore } from '@/stores/presentationStore';
import { useUserStore } from '@/stores/userStore';
import { mapActions, mapGetters } from 'pinia';
import ModalConfirmLayout from '../layouts/ModalConfirmLayout.vue';
import ModalComponent from '../layouts/ModalComponent.vue';
import QRCodeStyling from "qr-code-styling";

export default {
  data() {
    return {
      showScrollButton: false,
      imageUrl: require('@/assets/TEG_INL_Location.jpg'),
      tagClicked:false,
      clickedTag:'All',
      selectedTag: 'All',
      presentationSelected: null,
      hoveredPresentation: null, 
      isNavbarBlue: false, 
      scrollProgress: 0,
      showModal: true,
      tags:['AI','AR/VR','Computer Vision','Electronics','Embedded System','Experimental','Firmware','Mechanical','Software','Visualization'],
      
      dotSize: 3,
      dotSpacing: 30, 
      gridColumns: 0, 
      gridRows: 0,
      dots: [],

      activeSection: 'projects',
      isDarkMode: false,
      competencesBanner: require('@/assets/siteTEG_banner_03.jpg'),
      aboutBanner: require('@/assets/INL_3d.jpg'),
      searchQuery: '',

      userSelected: null,
      isTVMode: false,
      currentIndexTVMode: 0,
      qrCodeUrl: '',
      videosToShow: [],

      codeInserted: '',
      presentationSelected_: null,
      checkCodeApprovalFeedback: '',

      privacyNoticeHtml: `
      <h6>Before accessing the sensitive information on this website, you must agree to the following confidentiality terms:</h6>
      <br>
      <ol>
          <li><b>Confidential Information</b>: The information contained within this website, which is
              and shall remain property of the International Iberian Nanotechnology Laboratory, is
              confidential and intended solely for authorized users. Unauthorized access, disclosure
              or distribution of this information is strictly prohibited. You agree and undertake not
              to copy, reduce to writing or otherwise record the Confidential Information, and also
              not to file or obtain any patent application(s) or attempt to obtain any patent
              protection or other industrial or intellectual property rights on results, ideas,
              inventions or discoveries arising from the review, evaluation and/or discussion of the
              Confidential Information.
          </li>

          <li><b>Use of Information</b>: Any information accessed through this website is for
              authorized use only. You agree to use this information solely for the purpose for which
              it is intended and to maintain its confidentiality. You undertake to keep the
              Confidential Information confidential and to ensure the preservation and maintenance of
              the confidential status of such Confidential Information.
          </li>

          <li><b>Non-Disclosure</b>: You agree not to disclose any information obtained from this
              website to any third party, directly or indirectly, fully or partially, by yourself or
              through third parties, without prior written consent from the owner of the information.
          </li>

          <li><b>Security Measures</b>: We have implemented stringent security measures to protect the
              confidentiality of the information stored on this website. However, you are responsible
              for maintaining the security of your login credentials and ensuring that unauthorized
              access does not occur. By accessing to this website you undertake and agree to apply the
              same security measures and degree of care to the Confidential Information as you apply
              to your own Confidential Information, which you warrant as providing adequate protection
              from unauthorised disclosure, copying or unauthorised use.
          </li>

          <li><b>No Licenses</b>: the disclosure of the Confidential Information contained in this
              website shall not be construed as granting to you, or to any third party, either
              expressly or by implication, any right or license to the Confidential Information or to
              any patent, patent application, trade secret, trade or service mark, copyright or other
              industrial or intellectual property rights held by and/or in the name of the
              International Iberian Nanotechnology Laboratory nor any option to any such right or
              license.
          </li>

          <li><b>Information provided “as is”</b>: Any and all Confidential Information disclosed in
              this website is provided ‘as is’. The International Iberian Nanotechnology Laboratory
              does not give any representation, warranty or guarantee (express or implied) regarding
              the accuracy, completeness or suitability for any purpose of any disclosed Confidential
              Information. The International Iberian Nanotechnology Laboratory will not be held
              responsible or liable for any loss or damage of whatsoever nature that may arise as a
              result of the reliance on disclosed Confidential Information. The disclosure of
              Confidential Information in this website shall not form any offer by, or representation
              or warranty on the part of The International Iberian Nanotechnology Laboratory to enter
              into any agreement.
          </li>

          <li><b>Legal Compliance</b>: You agree to comply with all applicable laws and regulations
              regarding the protection of confidential information, including but not limited to data
              protection laws and any and all applicable intellectual property rights independently of
              their nature and the country in which you access the Confidential Information.
          </li>

          <li><b>Liability</b>: You acknowledge that any unauthorized use or disclosure of
              confidential information, or any violation to the rules contained in this message or
              within its spirit and scope of application, may result in legal action and/or damages.
              You agree to indemnify and hold harmless the website owner from any claims, losses, or
              damages arising out of your breach of this agreement.
          </li>
      </ol>
      <p>By clicking "Agree" or accessing the sensitive information on this website, you signify your
        acceptance of these confidentiality terms. If you do not agree with these terms, please refrain
        from accessing the information and exit this website immediately.
      </p>`, 
    };
  },
  components: {
    ModalComponent,
    ModalConfirmLayout
  },
  computed: {
    ...mapGetters(usePresentationStore, ['getPresentations','getApiBaseUrl','getAutoplay']),
    ...mapGetters(useUserStore, ['getUsers']),
    filteredPresentations() {
      let presentations = this.selectedTag === 'All'
        ? this.getPresentations
        : this.getPresentations.filter(presentation =>
            presentation.tags.includes(this.selectedTag)
          );

      if (this.searchQuery.trim() !== '') {
        const query = this.searchQuery.toLowerCase();
        presentations = presentations.filter(presentation =>
          presentation.projectName.toLowerCase().includes(query)
        );
      }

      return presentations;
    },
  },
  async mounted() {
    this.loadTheme();
    window.addEventListener('scroll', this.handleScroll);
    this.calculateGrid();
    window.addEventListener('resize', this.calculateGrid);
    window.addEventListener('mousemove', this.onMouseMove);
    this.codeInserted = this.$route.query.code;
    try {
      await this.fetchPresentations(this.codeInserted);
      await this.fetchUsers();
    } catch (err) {
      console.log(err)
    }
  },
  methods: {
    ...mapActions(usePresentationStore, ['fetchPresentations','fetchPresentation','fetchPresentationsWithMedias']),
    ...mapActions(useUserStore, ['fetchUsers']),
    handleScroll() {
      let bannerHeight = this.$refs.banner ? this.$refs.banner.clientHeight : 0; 
      this.isNavbarBlue = window.scrollY >= bannerHeight;

      const documentHeight = document.documentElement.scrollHeight;
      const viewportHeight = window.innerHeight;
      const scrollTop = window.scrollY;

      this.scrollProgress = (scrollTop / (documentHeight - viewportHeight)) * 100;

      this.showScrollButton = window.scrollY > 200;

      const tvModeElement = document.getElementsByClassName("tv-mode")[0];

      if(tvModeElement){
        const rect = tvModeElement.getBoundingClientRect();

        if (rect.top < window.innerHeight && rect.bottom >= 0) {
          this.isTVMode = true;
        } else {
          this.isTVMode     = false; 
          this.videosToShow = [];
        }
      }
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth" 
      });
    },
    setTheme(theme) {
      document.body.setAttribute('data-bs-theme', theme);
      localStorage.setItem('theme', theme);
      this.isDarkMode = localStorage.getItem('theme') === 'dark';
    },
    loadTheme() {
      const savedTheme = localStorage.getItem('theme') || 'light';
      this.setTheme(savedTheme);
    },
    toggleTheme() {
      this.isDarkMode = !this.isDarkMode;
      const theme = this.isDarkMode ? 'dark' : 'light';
      this.setTheme(theme);
    },
    getColor(tag) {
      switch (tag) {
        case 'AI':
          return '#2ecc71'; // Green
        case 'AR/VR':
          return '#e74c3c'; // Red
        case 'Computer Vision':
          return '#9b59b6'; // Purple
        case 'Electronics':
          return '#e67e22'; // Orange
        case 'Embedded System':
          return '#3498db'; // Light Blue
        case 'Experimental':
          return '#34495e'; // Dark Blue/Gray
        case 'Firmware':
          return '#f1c40f'; // Yellow
        case 'Mechanical':
          return '#f39c12'; // Dark Yellow/Orange
        case 'Software':
          return '#1abc9c'; // Teal
        case 'Visualization':
          return '#e84393'; // Pink
        default:
          return '#95a5a6'; // Gray
      }
    },
    getIcon(tag) {
      switch (tag) {
        case 'AI':
          return 'fas fa-robot';
        case 'AR/VR':
          return 'fas fa-vr-cardboard';
        case 'Computer Vision':
          return 'fas fa-eye';
        case 'Electronics':
          return 'fas fa-server';
        case 'Embedded System':
          return 'fas fa-microchip';
        case 'Experimental':
          return 'fas fa-flask';
        case 'Firmware':
          return 'fas fa-code';
        case 'Mechanical':
          return 'fas fa-cogs';
        case 'Software':
          return 'fas fa-laptop-code';
        case 'Visualization':
          return 'fas fa-chart-bar';
        default:
          return ''; 
      }
    },
    updateUserApproval() {
      const userApproval = JSON.parse(localStorage.getItem('userApproval')) || {};

      userApproval[this.codeInserted] = {
        approved: true,
        approvalDate: new Date().toISOString(),
      };

      localStorage.setItem('userApproval', JSON.stringify(userApproval));
    },
    checkUserApproval(code) {
      const userApproval = JSON.parse(localStorage.getItem('userApproval')) || {};
      const codeApproval = userApproval[code];
      if (codeApproval) {
        const { approved, approvalDate } = codeApproval;
        const fiveMinutesAgo = new Date(Date.now() - 5 * 60 * 1000);
        if (approved && new Date(approvalDate) > fiveMinutesAgo) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    calculateGrid() {
      const width = window.innerWidth; 
      const height = window.innerHeight; 

      this.gridColumns = Math.round(width / (this.dotSize + this.dotSpacing));
      this.gridRows = Math.round(height / (this.dotSize + this.dotSpacing));

      const totalDots = this.gridColumns * this.gridRows;
      this.dots = Array.from({ length: totalDots }, (_, index) => {
        const top = Math.round(index / this.gridColumns) * (this.dotSize + this.dotSpacing);
        const left = (index % this.gridColumns) * (this.dotSize + this.dotSpacing);
        return { top, left, isActive: false };
      });
    },
    onMouseMove(event) {
      const mouseX = event.clientX;
      const mouseY = event.clientY;
      const radius = 65; 

      this.dots.forEach(dot => {
        const distance = Math.sqrt(
          Math.pow(dot.left - mouseX, 2) + Math.pow(dot.top - mouseY, 2)
        );

        dot.isActive = distance < radius;
      });
    },
    async blobToBase64(blob) {
      return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
      });
    },
    async activateTvMode(){
      this.isTVMode = true;
      this.$refs.CodeModal.show();
    },
    async activateTvMode_(){
      const qrCode = new QRCodeStyling({
        width: 1080,
        height: 1080,
        margin: 15,
        type: "png",
        data: `${window.location.origin}${this.$route.path}?code=${this.$route.query.code}`,
        image: require('@/assets/logoTEG.png'),
        dotsOptions: {
            color: "#000",
            type: "extra-rounded",
        },
        backgroundOptions: {
            color: "#fff",
        },
        imageOptions: {
            crossOrigin: "anonymous",
            margin: 0,
            imageSize: 0.4
        },
        cornersDotOptions :{
            type: "extra-rounded",
            color: "#000",
        },
        cornersSquareOptions :{ 
            type: "extra-rounded",
        }
      });

      const qrBlob = await qrCode.getRawData("png");
      const qrImageBase64 = await this.blobToBase64(qrBlob);
      this.qrCodeUrl = `${qrImageBase64}`;

      window.scrollTo(0, document.body.scrollHeight); 
    },
    onVideoEnded() {
      if (this.currentIndexTVMode + 1 < this.videosToShow.length) {
        this.currentIndexTVMode++; 
      } else {
        this.currentIndexTVMode = 0;
      }
    },
    openPresentation(presentationID){
      this.presentationSelected_ = presentationID;
      this.$refs.CodeModal.show();
    },
    async checkCodeApproval(){
      try{
        if(this.isTVMode){
          let presentations = await this.fetchPresentationsWithMedias(this.codeInserted);

          this.$refs.CodeModal.hide();

          if(this.checkUserApproval(this.codeInserted)){
            presentations.forEach(presentation => {
              if (presentation.movies && presentation.movies.length) {
                presentation.movies.forEach((movie, index) => {
                  this.videosToShow.push({
                    src: this.getApiBaseUrl + movie, 
                    title: presentation.moviesTitles[index], 
                    description: presentation.description
                  });
                });
              }
            });

            this.activateTvMode_();
          }else{
            this.$refs.ModalConfirm.open(this.privacyNoticeHtml,'modal-lg','Privacy Notice')
              .then(() => {
                this.updateUserApproval();

                presentations.forEach(presentation => {
                  if (presentation.movies && presentation.movies.length) {
                    presentation.movies.forEach((movie, index) => {
                      this.videosToShow.push({
                        src: this.getApiBaseUrl + movie, 
                        title: presentation.moviesTitles[index], 
                        description: presentation.description
                      });
                    });
                  }
                });

                this.activateTvMode_();
              })
              .catch((error) => {
                this.videosToShow = [];
                console.log('error',error);
              });
          }

        }else{
          let presentation          = await this.fetchPresentation(this.codeInserted,this.presentationSelected_);
          this.presentationSelected = presentation;

          this.$refs.CodeModal.hide();

          if(this.checkUserApproval(this.codeInserted)){
            this.$nextTick(() => {this.$refs.PresentationModal.show();})
          }else{
            this.$refs.ModalConfirm.open(this.privacyNoticeHtml,'modal-lg','Privacy Notice')
            .then(() => {
              this.updateUserApproval();
              this.$refs.PresentationModal.show();
            })
            .catch((error) => {
              this.presentationSelected = null;
              console.log('error',error);
            });
          }
        }
      }catch(err){
        console.log(err)
        this.isTVMode                   = false;
        this.checkCodeApprovalFeedback  = err;
      }
    }
  },
};

</script>

<style lang="scss">
  @import '@/styles/variables'; 

  .scroll-top-btn {
    position: fixed;
    bottom: 50px;
    right: 50px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 50%;
    width: 70px;
    height: 70px;
    font-size: 18px;
    cursor: pointer;
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0.8;
    transform: scale(1.0);
    transition: opacity 0.3s ease, transform 0.3s ease;
  }

  .scroll-top-btn:hover {
    opacity: 1;
    transform: scale(1.2)
  }

  .team-btn {
    position: fixed;
    bottom: 50px;
    left: 50px;
    background-color: #820bea;
    color: white;
    border: none;
    border-radius: 50%;
    width: 70px;
    height: 70px;
    font-size: 18px;
    cursor: pointer;
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0.8;
    transform: scale(1.0);
    transition: opacity 0.3s ease, transform 0.3s ease;
  }

  .team-btn:hover {
    opacity: 1;
    transform: scale(1.2)
  }

  .presentationCard {
    transform: scale(1.0);
    transition: transform 0.4s ease; 
    border-radius: 10px !important;
  }

  .presentationCard:hover {
    cursor: pointer;
    transform: scale(1.03);
  }

  .user{
    box-shadow: 0 5px 25px 0 rgba(0, 0, 0, .2) !important;
    transform: scale(1.0);
    transition: transform 0.4s ease;
  }

  .user:hover{
    cursor: pointer;
    transform: scale(1.03);
  }

  .fullscreen-video-container {
    position: relative;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    z-index: 1000;
  }

  .fullscreen-video {
    position: absolute;
    top: 50%;
    left: 50%;
    min-width: 100%;
    min-height: 100%;
    width: auto;
    height: auto;
    z-index: -1; 
    transform: translate(-50%, -50%);
    object-fit: cover;
  }

  .scroll-button {
    position: absolute;
    bottom: 30px;
    left: 50%;
    transform: translateX(-50%);
    padding: 10px 20px;
    z-index: 1;
    transition: background-color 0.5s ease, border-radius 0.5s ease;
  }

  .scroll-button:hover {
    cursor: pointer;
    background-color: rgba(255, 255, 255, 0.425); 
    border-radius: 2px !important;
  }

  ._nav-item{
      padding-left:16px;
      padding-right:16px;
      padding-top: 8px;
      padding-bottom:8px;
      transition: background-color 0.5s ease, border-radius 0.5s ease;
  }

  ._nav-item:hover {
      cursor: pointer;
      background-color: rgba(255, 255, 255, 0.425); 
      border-radius: 2px !important;
  }

  nav {
    background-color: none;
    transition: background-color 0.8s ease;
  }

  .navbar-bg-blue {
    transition: background-color 0.8s ease;
    // background: linear-gradient(45deg, #ffffff 40%, #005f80 40%);
    background-color: #005f80; 
    // background-color: #ffffff;
    box-shadow: 0 5px 25px 0 rgba(0, 0, 0, .2) !important;
    animation: colorCycle 6s infinite 3s;
  }

  // @keyframes colorCycle {
  //   0% {
  //     background-color: $primary;
  //   }
  //   50% {
  //     background-color: $danger;
  //   }
  //   100% {
  //     background-color: $primary; 
  //   }
  // }

  .tag{
    overflow: hidden;
    white-space: nowrap; 
  }

  .tag-text {
    max-width: 0px;
    opacity: 0;
    transform: translateX(-10px);
    transition: opacity 0.9s ease, transform 0.9s ease, max-width 0.8s ease;
  }

  .tag:hover .tag-text {
    max-width: 200px;
    opacity: 1;
    display: flex; 
    cursor: pointer;
    transform: translateX(0); 
    margin-left:3px
  }

  .footer-notice {
    text-align: justify;
    font-size: 12px;
  }

  @media (max-width: 768px) {
    .footer-notice {
      font-size: 11px;
      line-height: 1.2;
    }
  }

  .tagSelect{
    transition: flex-grow 0.3s ease, width 0.3s ease;
  }

  .tags{
    position: relative;
    z-index: 2 !important;
    box-shadow: 0 5px 25px 0 rgba(0, 0, 0, .2) !important;
  }

  .dots-container{
    position:fixed;
    top:0;
    left:0;
    height: 100vh;
    width: 100vw;
    z-index:0
  }

  .dot {
    position: absolute;
    border-radius: 50%;
    transition: background-color 0.3s ease;
  }

  ._nav-item.active {
    border-bottom: 4px solid #e8e8e8;
    z-index: 100000;
  }

  .tv-mode{
    position: relative;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 1000000;
    background-image: url('@/assets/layered-waves-haikei (16).svg');
    background-repeat: no-repeat;
    background-size: cover;
    background-attachment: fixed;
  }

  .widgets{
    position: absolute;
    bottom: 0px;  
    right: 0px;  
    width: 18%; 
    z-index: 10; 
    padding: 20px;
  }

  .qr-code {
    border-radius: 8px;
    width: 100%; 
  }

  .teg-logo {
    border-radius: 8px;
    width: 100%; 
    margin-bottom:60px;
  }

  .video-tv-mode{
    position: absolute;
    top: 0;
    left: 0;
    width: 82%;
    height: 82%
  }

  .title-video-tv-mode{
    position: absolute;
    top: 84%;  
    left: 10px;  
    width: 82%;
  }

  .blur-sm {
      filter: blur(3px) saturate(0.6);
  }
</style>